import React, { Component } from 'react'
import Select, { Creatable, Async } from 'react-select';
import classNames from 'classnames';
import { TIPOS_VEHICULOS } from '../../../../utility/constants';


export default class ToolbarVehiculos extends Component {
    render() {
        const { changeTipo } = this.props;
        return (
            <div className="row col-12 p-0 m-0">
                <div className="col-12 p-0 m-0 ">
                    <Select
                        isClearable={true}
                        className={classNames('react-select-container')}
                        backspaceRemovesValue={true}
                        isSearchable={true}
                        options={TIPOS_VEHICULOS}
                        placeholder={"Tipo"}
                        // value={null}
                        onChange={(e, action)=>{console.log(e, action); changeTipo(e)}}
                    />
                </div>
            </div>
        )
    }
}